<script>
import { mapGetters } from "vuex";
import getNavType from "@/components/mixins/getNavType";

function mid(val, min, max) {
  return Math.min(Math.max(min, val), max);
}

export default {
  mixins: [getNavType],
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "TopNav_Size",
      "MaterialPane_Size",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "Window_Size",
      "SpriteBeforeSwap"
    ])
  },
  data() {
    return {
      spriteType: "",
      isShowMask: false,
      rect: null,
      sprite: {}, // 选中的元素
      movable: true,
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        moveoks: false, // 拖动判读啊数据
        oldMove: {
          // 计算移动增量
          x: 0,
          y: 0
        },
        fix: {
          // 弹窗位置
          x: 0,
          y: 0
        }
      }
    };
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      let myType = this.popupType || this.spriteType;
      let num = Array.indexOf(this.boxDatas.firstDatas, myType);
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开
      if (!this.boxData.judgeBox) {
        this.toggleMask(this.boxData.judgeBox);
        this.rect = null;
      }

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        let myData = (this.boxData.data = this.dataMsg[myType]);
        this.sprite = this.boxData.data.sprite;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;

        let oSprite = this.boxData.data.sprite || this.SelectSprites_Msg[0];
        this.boxData.fix.x =
          myData.initialX && myData.initialX != null
            ? myData.initialX
            : this.TOOL.PfixLeft + (oSprite ? oSprite.positionLeft: 0) - 280;
        this.boxData.fix.y =
          myData.initialY && myData.initialY != null
            ? myData.initialY
            : this.TOOL.PfixTop +
              (oSprite ? oSprite.positionTop: 0);

        if (myData.isChild) {
          this.boxData.fix.x += 40;
          this.boxData.fix.y += 40;
        }
          console.log(`Turbo ~ myData`, myData)

        this.source = myData.source;
        this.$bus.emit("show" + (myType ? "." + myType : ".firstPopup"), {
          component: this
        });

        this.$nextTick(() => {
          this.setInWindowVertival();
        });
      }
      if (this.rect) {
        this.boxData.fix.x = this.rect.left;
        this.boxData.fix.y = this.rect.top;
      }
    },
    "boxData.fix.x": function(val, oldval) {
      // 位置判断的200写死有问题修改的话，记得考虑字体弹窗
      this.boxData.fix.x =
        this.boxData.fix.x < 0
          ? 0
          : this.boxData.fix.x + 200 > window.innerWidth
          ? window.innerWidth - 200
          : this.boxData.fix.x;
    },
    "boxData.fix.y": function(val, oldval) {

      this.boxData.fix.y =
        this.boxData.fix.y < 0
          ? 0
          : this.boxData.fix.y + 30 > window.innerHeight
          ? window.innerHeight - 30
          : this.boxData.fix.y;
    },
    "TOOL.selectedSprite": {
      handler(val) {
        if (!val || !val.length) {
          this.close();
        }
      }
    },
    "boxData.judgeBox": {
      handler(val, oldVal) {
        // if (val === oldVal && oldVal === false) {
        //   return;
        // }
        this.$bus.emit("spritePopup.visibilityChange", {
          flag: this.boxData.judgeBox,
          component: this
        });
      }
    }
  },
  created() {
    this.$bus.on("undoRedoHandle", ({ type, mod } = {}) => {
      const vm = this;
      if (!vm.boxData.judgeBox) {
        return;
      }
      typeof this.render === "function" && this.render();
    });
  },
  mounted() {
    this.$bus.on("Document_mousemove_vue", event => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on("Document_mouseup_vue", event => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.saveMoveState(e);
        return false;
      }
    });
  },
  methods: {
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    moveStart(e, bol) {
      // 移动启动
      if(!bol) {
        this.boxData.moveoks = false;
        return;
      }
      this.boxData.moveoks = true;
      this.boxData.oldMove = {
        x: e.pageX,
        y: e.pageY
      };
      e.onselectstart = () => {
        //防止IE文字选中
        return false;
      };
    },
    moveArea(e) {
      // 拖动元素计算
      if (this.boxData.moveoks) {
        let Incremental = {
          x: this.boxData.oldMove.x - e.pageX,
          y: this.boxData.oldMove.y - e.pageY
        };
        this.boxData.oldMove = {
          x: e.pageX,
          y: e.pageY
        };
        this.boxData.fix = {
          x: mid(this.boxData.fix.x - Incremental.x, 0, window.innerWidth - 200),
          y: mid(this.boxData.fix.y - Incremental.y, 0, window.innerHeight - 30)
        };
      }
    },
    saveMoveState(e) {
      // 保存移动状态
      if(this.boxData.moveoks) {
        this.boxData.moveoks = false;
        this.rect = this.$el.getBoundingClientRect();
      }
    },
    close() {
      this.popupType = this.popupType || this.spriteType;
      if (this.colorPopupType) {
        this.$bus.emit("FeaturesPop_close_vue", {
          name: this.colorPopupType,
          type: 1
        });
      }
      this.$bus.emit("FeaturesPop_close_vue", {
        name: this.popupType,
        type: 1
      });

      this.toggleMask(false);
      if (this.source && typeof this.source.toggleMask === "function") {
        this.source.toggleMask(false);
      }
    },
    arrangeAction(flag) {
      let sprite = this.dataMsg[this.spriteType].sprite;
      switch (flag) {
        case "front":
          this.TOOL.moveSpriteTo(
            sprite.id,
            this.SelectScenes_Msg.sprites.length,
            true
          );
          break;
        case "back":
          this.TOOL.moveSpriteTo(sprite.id, 0, true);
          break;
        case "forward":
          this.TOOL.moveSpriteTo(sprite.id, sprite.index + 1, true);
          break;
        case "backward":
          this.TOOL.moveSpriteTo(sprite.id, sprite.index - 1, true);
          break;
      }
    },
    /* getNavType () {
      let { type } = this.SelectSprites_Msg[0];
      let { fileType } = this.SelectSprites_Msg[0].option;
      let navs = {
        'scenes': [],
        'bg': [],
        'text': [11, 12],
        'characters': [10],
        'props': [3, 4, 5],
        'shapes': [7, 8],
        'sound': [],
      };
      let navs2 = {
        'scenes': [],
        'bg': [],
        'text': ['Text'],
        'characters': ['Lottie'],
        'props': ['Image'],
        'shapes': ['Svg', 'Shape', 'Chart'],
        'sound': [],
      }
      if (fileType != null) {
        return find(navs, fileType);
      } else {
        return find(navs2, type);
      }

      function find (navs, targetKey) {
        let myKey = Object.keys(navs).filter((key) => {
          return navs[key].indexOf(targetKey) > -1;
        })[0];
        return myKey;
      }
    }, */
    operationsAction(flag) {
      switch (flag) {
        case "swap": {
          let longType = this.getNavType();
          let typeArr = longType.split(".");
          // 打开 rightNav
          this.$bus.emit("materialPane_vue", {
            type: typeArr[0],
            name: typeArr[1],
            judge: !!typeArr[1]
          });
          this.close();
          this.$store.commit("save_SpriteOperation", "swap");
          // 弹出气泡提示
          this.$bus.emit("blackPopupMsg_showTips", {
            text: "选择左边的素材可进行替换",
            position: {
              top: "186px",
              left: this.MaterialPane_Size.width + 20 + "px"
            }
          });
          // this.$bus.emit('toggleToolMask', {
          //   isShow: true,
          // });
          break;
        }
        case "flip":
          this.sprite.flipStyle(true);
          this.sprite.changeStyle({ sync: true });
          break;
        case "crop":
          this.$bus.emit("cropImageStart");
          break;
        case "edit":
          // const lottie = this.sprite.lottie
          // this.sprite.ele.html('');
          // this.sprite.lottie = window.lottie.loadAnimation({
          //   container: this.sprite.ele[0],
          //   renderer: 'svg',
          //   loop: false,
          //   autoplay: true,
          //   path: lottie.path+lottie.fileName+'.json'
          // });
          break;
        case "edit_chartTable":
          // 发送事件到popups，显示一级弹窗
          this.$bus.emit("FeaturesPop_vue", {
            name: "edit_chartTable",
            // 使表格弹窗在画布居中显示，867和282分别为表格的宽高。
            posx:
              this.MaterialPane_Size.width +
              this.TOOL.fixLeft +
              (this.TOOL.clientWidth - 867) / 2,
            posy:
              this.TopNav_Size.height +
              this.TOOL.fixTop +
              (this.TOOL.clientHeight - 282) / 2,
            sprite: this.SelectSprites_Msg[0],
            type: 1
          });
          break;
      }
    },
    toggleMask(flag) {
      this.isShowMask = flag;
    },
    // 关闭此弹窗呼出的下一个一级弹窗
    closeNextPopup(name) {
      this.$bus.emit("FeaturesPop_close_vue", {
        name,
        type: 1
      });
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "effectOptions",
        type: 1
      });
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "fontFamily",
        type: 1
      });
      this.toggleMask(false);
    },
    getComponent() {
      return this;
    },
    setInWindowVertival() {
      let h = this.$el.offsetHeight + 20;
      this.boxData.fix.y =
        this.boxData.fix.y < 0
          ? 0
          : this.boxData.fix.y + h > window.innerHeight
          ? window.innerHeight - h
          : this.boxData.fix.y;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mixins/popup.vue